
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
this.list = [{
label: '中文名称',
value: this.$route.params.Item.PC_Name_Ch
}, {
label: '英文名称',
value: this.$route.params.Item.PC_Name_En
}, {
label: '英文简称',
value: this.$route.params.Item.PC_En_Abbreviation
}, {
label: '优惠/普通税率标记',
value: this.$route.params.Item.PC_TaxRateSign
}, {
label: '船舶吨税优/普标记',
value: this.$route.params.Item.PC_ShippTonnageTaxSign
}]
}
}



// WEBPACK FOOTER //
// ./src/components/CountryDetail.vue